module.exports = __webpack_public_path__ + "img/seckill_01.bbe65a41.png";